import { FunctionComponent, ReactNode } from "react";
import NavBar from "../components/Navbar";
import Footer from "../components/Footer";
import BookTimeCard from "../components/BookTimeCard";
import RecentArticleCard from "../components/RecentArticleCard";
import SubHeaderText from "../components/SubHeaderText";

type Service = {
  headerOne?: string;
  headerTwo?: string | ReactNode;
  img?: string;
  section?: ReactNode;
  customWidth?: string;
};

const Services: FunctionComponent<Service> = ({
  headerOne,
  headerTwo,
  img,
  section,
  customWidth,
}) => {
  return (
    < >
        <div className="pt-20 max-md:pt-12">
          <SubHeaderText
            img={img}
            header="Ydelser"
            headerTwo={headerOne}
            qoute={headerTwo}
            customWidth={customWidth}
          ></SubHeaderText>
        </div>
        <div className="max-w-[1960px] mx-auto max-md:w-10/12">
          <div className="max-w-[935px] pt-24 max-md:pt-10 pb-24 mx-auto md:pl-24">
            {section}
          </div>

          {/*________________________________________________________________________________________________________________________________________________ */}
          <div className="relative pt-32 max-md:pt-10">
            <div className="relative text-center text-5xl max-md:text-2xl text-gray-700">
              <b className="w-10/12 ">Seneste artikler</b>
            </div>
            <div className="relative pt-3 text-center mx-auto my-0 max-md:text-3xs text-2xs text-gray-700 w-4/12 max-md:w-10/12">
              Følg med i de seneste nyheder og artikler omkring gode tips og råd
              til et sundere sind.
            </div>

            <div className="relative flex max-md:flex-col max-md:gap-y-5 items-center gap-10 justify-evenly pt-24">
            <RecentArticleCard
                url="/artikler/hjerterum"
                image="../chap1.webp"
                imageMobile="../chap1-50.webp"
                header="Hjerterum - øvelser og meditationer"
                readTime={6}
                date="03/12-2019"
              ></RecentArticleCard>
              <RecentArticleCard
                url="/artikler/skyggesider"
                image="../skyggesider.webp"
                imageMobile="../skyggesider-50.webp"
                header="Skyggesider - hvad mon mørket gemmer?"
                readTime={5}
                date="15/08-2020"
              ></RecentArticleCard>
              <RecentArticleCard
                url="/artikler/meditation"
                image="../stenbunke.webp"
                imageMobile="../stenbunke-50.webp"
                header="Meditation - en ny livsgivende vane"
                readTime={3}
                date="23/09-2020"
              ></RecentArticleCard>
            </div>
          </div>

      
        </div>
        <div className="pt-44 pb-80 relative max-md:pb-32 text-6xl text-colors-neutral-white font-bebas-neue">
            <BookTimeCard></BookTimeCard>
          </div>
    </>
  );
};

export default Services;
